import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Supplier } from "../models/supplier.model";
import * as moment from "moment";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root",
})
export class SupplierService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Supplier>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getSuppliers(shopId: string): AngularFirestoreCollection<Supplier> {
    return this.db.collection(this.dbPath + `/${shopId}/suppliers`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  getSupplier(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath + `/${shopId}/suppliers`).doc(id);

    return ref.get();
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/suppliers`)
      .doc(id)
      .valueChanges();
  }

  create(supplier: Supplier): any {
    supplier.isActive = true;
    supplier.isDeleted = false;
    supplier.createdOn = new Date();
    supplier.createdBy = this.userLogin.uid;
    supplier.updatedOn = new Date();
    supplier.updatedBy = this.userLogin.uid;
    supplier.author = this.userLogin;
    supplier.visibility = this.visibility;

    supplier.shopId = supplier.shopId ? supplier.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${supplier.shopId}/suppliers`
    );

    return this.collRef.add({ ...supplier }).then((docRef) => {
      supplier.id = docRef.id;
      return supplier;
    });
  }

  update(supplier: Supplier): Promise<void> {
    console.log("update supplier:", supplier);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${supplier.shopId}/suppliers`
    );
    return this.collRef.doc(supplier.id).update({
      email: supplier.email ? supplier.email : "",
      mobile: supplier.mobile ? supplier.mobile : "",
      cardId: supplier.cardId ? supplier.cardId : "",

      fullName: supplier.fullName ? supplier.fullName : "",
      firstName: supplier.firstName ? supplier.firstName : "",
      lastName: supplier.lastName ? supplier.lastName : "",
      dob: supplier.dob ? supplier.dob : new Date(),
      dobYear: supplier.dobYear ? supplier.dobYear : 2000,
      dobMonth: supplier.dobMonth ? supplier.dobMonth : 1,
      dobDay: supplier.dobDay ? supplier.dobDay : 1,
      gender: supplier.gender,
      address: supplier.address,
      tax: supplier.tax ? supplier.tax : "",
      description: supplier.description,
      coverUrl: supplier.coverUrl ? supplier.coverUrl : "",
      sourceType: supplier.sourceType,
      content: supplier.content ? supplier.content : "",
      videoUrl: supplier.videoUrl ? supplier.videoUrl : "",
      imagesUrl: supplier.imagesUrl ? supplier.imagesUrl : [],
      tags: supplier.tags ? supplier.tags : [],
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  updateOverview(supplier: Supplier): Promise<void> {
    console.log("updateOverview supplier:", supplier);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${supplier.shopId}/suppliers`
    );
    return this.collRef.doc(supplier.id).update({
      saleQuantity: supplier.saleQuantity ? supplier.saleQuantity : 0,
      saleAmount: supplier.saleAmount ? supplier.saleAmount : 0,
      paidAmount: supplier.paidAmount ? supplier.paidAmount : 0,
      debitAmount: supplier.debitAmount ? supplier.debitAmount : 0,
      profitAmount: supplier.profitAmount ? supplier.profitAmount : 0,
      isSynced: supplier.isSynced,
      syncedOn: updatedOn,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/suppliers`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  calculatorSuppliersDebt(shopId: string) {
    localStorage.setItem(
      `${shopId.toLowerCase()}_suppliers_syncedOn`,
      moment().format("YYYY-MM-DD HH:mm")
    );

    const callable = this.fns.httpsCallable(
      "api-systemConfig-calculatorSuppliersDebt"
    );
    return callable({
      shopId: shopId,
    });
  }

  updateSupplierOverview(shopId: string, supplierId: string) {
    const callable = this.fns.httpsCallable(
      "api-systemConfig-updateSupplierOverview"
    );
    return callable({
      shopId: shopId,
      supplierId: supplierId,
    });
  }
}
